import { PrimaryColumnSettingsMode } from '../types';

export const primaryColumnSettingsMode: PrimaryColumnSettingsMode = 'usa';
